import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { VendorCheckpointGeneratedPresignedURL } from "@services/checkpoint.service";
import { getValue } from "@utils/lodash";
import { downloadURL } from "@services/auth.service";
import { getEncodedKey } from "./text-helper";
export const handleS3FileDownloadOnClick = async (
  key: string,
  name: string
) => {
  // var link = document.createElement("a");
  // link.target = "_blank";
  // link.download = "Contact";
  // link.name ='sk'
  // link.href ='https://assets.surveydemolink.in/public/client1/reports/360-feedback/0eed191d-f24b-4578-8cb1-c7c3969cef52-Feedback-Report.pdf'
  // https://user-import.s3.ap-south-1.amazonaws.com/documents/7db528adb2067346bdb86e24c2b4fb41231fa9a1.pdf
  // link.click();
  if (key) {
    // let response = await VendorCheckpointGeneratedPresignedURL({
    //   key: key,
    //   image_name: name,
    //   action: "getObject",
    // });
    // let resp = await downloadURL(
    //   getEncodedKey(getValue(response, `data.url`, ""))
    // );
    // if (resp) {
    //   saveAs(getValue(resp, `data.url`, ""), name);
    // }
    try {
      let resp = await downloadURL(getEncodedKey(key));
      if (resp) {
        saveAs(getValue(resp, `data.url`, ""), name);
      }
    } catch (error) {
      toast.error("Something went wrong, Please try after sometime.");
    }
  } else {
    toast.error("Something went wrong, Please try after sometime.");
  }
};
